import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// --- CONFIGURAZIONE FIREBASE ---
// Usa variabili d'ambiente per sicurezza
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCO7MINjy5pSOKn6JRrxxsk74muAG8zelg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "itad-app.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "itad-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "itad-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "209990086104",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:209990086104:web:fe73b0fcb7d1c2894cd6ad"
};

// Inizializzazione Firebase
const app = initializeApp(firebaseConfig);

// Esportiamo i servizi per poterli usare in App.jsx e altri file
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');

// Opzionale: Emulator per sviluppo locale
// import { connectFunctionsEmulator } from "firebase/functions";
// if (process.env.NODE_ENV === 'development') {
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }